<template>
  <div class="section-main__warp system-param-page">
    <div class="left-menu">
      <div class="left-bg">
        <div class="parent-title">
          <i class="iconfont-lunan icon-lunan-lujing131"></i>
          <span class="title-text">参数设置</span>
        </div>
        <div
          class="title-item child-title"
          :class="{ active: activeCode === item.code }"
          @click="handleNodeClick(item.code)"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <i class="iconfont-lunan" :class="item.icon"></i>
          <span class="title-text">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="right-content">
      <el-form ref="form" style="height: 100%; width: 100%" :model="form" :rules="rules">
        <div ref="scrollView" class="param-form" id="param-form">
          <div v-for="item in dataList" :key="item.type" :id="'param-form-' + item.code">
            <div class="system-title" :class="{ active: activeCode === item.code }">
              # {{ item.name }}
            </div>
            <div v-if="params[item.code] && params[item.code].length" class="system">
              <div v-for="(val, index) in params[item.code]" :key="index" class="pt">
                <!-- cfgValueType : 文本类型 -->
                <div v-if="val.cfgValueType === '2'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}</div>
                  <el-form-item :prop="val['cfgCode']">
                    <el-input v-model="form[item.code][val['cfgCode']]"></el-input>
                  </el-form-item>
                  <div class="item-desc">{{ val.cfgDesc }}</div>
                </div>
                <!-- 文件 -->
                <div v-if="val.cfgValueType === '3'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}</div>
                  <audio
                    class="file-comp"
                    preload="auto"
                    style="width: 210px; height: 30px; margin: -20px 10px 0 -2px"
                    :controls="form[item.code][val['cfgCode']] ? true : false"
                    :src="form[item.code][val['cfgCode']]"
                  >
                    您的浏览器不支持audio播放
                  </audio>
                  <el-form-item :prop="val['cfgCode']">
                    <el-upload
                      :action="uploadUrl"
                      name="files"
                      :on-preview="onPreview"
                      :on-remove="
                        (file) => {
                          onRemove(val, file, index);
                        }
                      "
                      :before-upload="
                        (file) => {
                          return beforeAvatarUpload(val, file, index);
                        }
                      "
                      :on-exceed="videoExceed"
                      :on-success="
                        (response, file, fileList) => {
                          videoSuccess(response, file, fileList, index, val);
                        }
                      "
                      :limit="1"
                      :file-list="mp3fileList"
                    >
                      <el-button
                        size="small"
                        class="el-icon-top"
                        type="primary"
                        >点击上传</el-button
                      >
                    </el-upload>
                  </el-form-item>
                </div>
                <div v-else-if="val.cfgValueType === '6'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}</div>
                  <el-form-item :prop="val['cfgCode']">
                    <el-input
                      type="textarea"
                      v-model="form[item.code][val['cfgCode']]"
                      rows="10"
                      style="width: 500px"
                    ></el-input>
                  </el-form-item>
                  <div class="item-desc">{{ val.cfgDesc }}</div>
                </div>
                <div v-else-if="val.cfgValueType === '4'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}</div>
                  <el-form-item :prop="val['cfgCode']">
                    <el-select v-model="form[item.code][val['cfgCode']]">
                      <el-option
                        v-for="i in formatValue(val.cfgEnumMap)"
                        :key="i.value"
                        :label="i.label"
                        :value="i.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <div class="item-desc">{{ val.cfgDesc }}</div>
                </div>
                <div v-else-if="val.cfgValueType === '1'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}111</div>
                  <el-form-item :prop="val['cfgCode']">
                    <el-input
                      v-model="form[item.code][val['cfgCode']]"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <div class="item-desc">{{ val.cfgDesc }}</div>
                </div>
                <div v-else-if="val.cfgValueType === '5'" class="valign-center">
                  <div class="item-title">{{ val.cfgName }}</div>
                  <el-form-item :prop="val['cfgCode']">
                    <el-input-number
                      v-model="form[item.code][val['cfgCode']]"
                      controls-position="right"
                      :min="1"
                    ></el-input-number>
                  </el-form-item>
                  <div class="item-desc">{{ val.cfgDesc }}</div>
                </div>
              </div>
            </div>
            <!-- <div v-else class="system">
              <div class="pt">暂无数据</div>
            </div> -->
            <div class="flex-center">
              <el-button
                v-auth="'/system:update'"
                type="primary"
                :loading="saveLoading"
                @click="submitSingleForm(params[item.code], item.code)"
                >{{ saveLoading ? "保存中" : "保存" }}</el-button
              >
            </div>
          </div>
        </div>
      </el-form>
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>
<script>
import api from "../api";
export default {
  components: {},
  data() {
    return {
      uploadUrl: api.system.batchFileload,
      mp3fileList: [],
      dataList: [],
      params: {},
      form: {},
      rules: {},
      activeCode: -1,
      saveLoading: false,
    };
  },
  beforeDestroy() {
    this.scrollView.removeEventListener("scroll", this.scrollContainer, false);
  },
  computed: {},
  mounted() {
    // 通过$refs获取dom元素
    this.scrollView = this.$refs.scrollView;
    // 监听这个dom的scroll事件
    this.scrollView.addEventListener("scroll", this.scrollContainer, false);

    this.iconMap = {
      1: "icon-lunan-xitongshezhi",
      2: "icon-lunan-zu119",
      3: "icon-lunan-lujing133",
      4: "icon-lunan-cheliangjiansuotubiao",
      5: "icon-lunan-renchetaishi",
      6: "icon-lunan-app",
      7: "icon-lunan-xiaofangbanshou",
      8: "icon-lunan-renwuguanli1",
    };
    this.$fetch(api.system.getData).then((res) => {
      if (res.success && res.returnObj && res.returnObj.length) {
        res.returnObj.map((val) => {
          val.icon = this.iconMap[val.code];
          this.dataList.push(val);
          this.params[val.code] = [];
          let param = {
            categoryId: val.code,
            cfgCode: "",
            cfgDesc: "",
            pageNum: 1,
            pageSize: 1000,
          };
          this.$log.debug("val.code", val.code);

          this.$set(this.form, val.code, {});
          this.$fetch(api.system.getList, param).then((data) => {
            let result = data.returnObj.list;
            result.map((item) => {
              this.$set(this.form[val.code], item.cfgCode, item.cfgValue);
              this.$set(this.rules, item.cfgCode, []);
              this.rules[item.cfgCode].push({
                validator: (rule, value, callback) => {
                  if (item.validator) {
                    let reg = new RegExp(item.validator);
                    if (!reg.test(this.form[val.code][item.cfgCode])) {
                      callback(new Error(item.cfgDesc));
                    } else {
                      callback();
                    }
                  } else {
                    callback();
                  }
                },
                trigger: "blur",
              });
            });
            this.params[val.code] = result;
          });
        });
        this.dataList.sort((prev, next) => {
          return prev.code - next.code;
        });
        this.activeCode = this.dataList[0].code;
      }
    });
    console.log(this.params);
    console.log("---规则-----", this.form);
  },
  methods: {
    formatValue(obj) {
      let values = Object.values(obj);
      let keys = Object.keys(obj);
      let arrays = [];
      keys.forEach((el, index) => {
        arrays.push({
          label: values[index],
          value: el,
        });
      });
      return arrays;
    },
    onPreview() {},
    onRemove(val, file, index) {
      this.form[val.categoryId][val.cfgCode] = "";
    },
    videoSuccess(res, file, fileList, index, val) {
      // console.log(val)
      this.form[val.categoryId][val.cfgCode] = res.returnObj[0].url;
      // console.log(this.form)
    },
    videoExceed() {
      this.$message.warning("最多可上传1个音频");
    },
    beforeAvatarUpload(val, file, index) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "mp3";
      if (!extension) {
        this.$message({
          message: "上传文件只能是mp3格式！",
          type: "error",
        });
        this.$nextTick(() => {
          this.form[val.categoryId][val.cfgCode] = this.params[2][index].cfgValue;
        });
      }
      return extension;
    },
    scrollContainer() {
      var current_offset_top = this.$refs.scrollView.scrollTop;
      for (let i = 0; i < this.dataList.length; i++) {
        let itemCode = this.dataList[i].code;
        let dom = document.getElementById("param-form-" + itemCode);
        let domTop = dom.offsetTop;
        let domHeight = dom.offsetHeight;
        if (domTop - 60 + domHeight / 2 >= current_offset_top) {
          this.activeCode = itemCode;
          break;
        }
      }
    },
    handleNodeClick(code) {
      this.activeCode = code;
      let form = document.getElementById("param-form");
      let dom = document.getElementById("param-form-" + code);
      form.scrollTo(0, dom.offsetTop - form.offsetTop);
      // this.$refs["scroll"].wrap.scrollTop = dom.offsetTop - form.offsetTop;
    },
    submitSingleForm(data, code) {
      // if (code == "2") {
      //   if (
      //     Object.keys(this.form[2]).length !=
      //     Object.values(this.form[2]).filter((val) => val != "").length
      //   ) {
      //     this.$message.error("请将告警中心参数设置填写完整");
      //     return;
      //   }
      // }
      let keys = [];
      let param = {
        sysConfigList: [],
      };
      for (let key in this.form[code]) {
        keys.push(key);
        param.sysConfigList.push({
          categoryId: code,
          cfgCode: key,
          cfgValue: this.form[code][key],
        });
      }
      let validateList = [];
      this.$refs["form"].validateField(keys, (message) => {
        validateList.push(message);
      });
      if (validateList.every((item) => item === "")) {
        this.saveLoading = true;
        const loading = this.$loading({
          lock: true,
          text: "提交中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$fetch(api.system.submit, param).then((res) => {
          if (res.success) {
            this.$message.success(res.msgContent);
            this.$store.dispatch("GetSysOptions");
          } else {
            this.$message.error(res.msgContent);
          }
          setTimeout(() => {
            loading.close();
            this.saveLoading = false;
          }, 500);
        });
      } else {
        this.$message.error("请检查表单是否填写完整");
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:deep .el-upload-list {
  position: absolute;
  top: -5px;
  left: 85px;
  li {
    color: black;
    background: #fff;
    margin-right: 30px;
    a {
      text-decoration: none;
    }
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.system-param-page {
  .system-title {
    margin-top: 10px;
    font-size: 16px;

    &.active {
      font-size: 18px;
      @include set_theme_color(color, main-theme-color);
    }
  }

  .system {
    @include set_theme_color(background-color, left-menu-bg-color);
    margin: 10px 0px 16px 0px;
  }
  .pt {
    display: inline-block;
    padding: 10px 10px 0 16px;
    min-width: 50%;
  }
  .left-menu {
    width: 380px;
    .left-bg {
      height: 100%;
      padding: 16px 0;
      @include set_theme_color(background-color, left-menu-bg-color);
    }
  }
  .parent-title {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .title-item {
    padding: 10px 20px;
  }
  .child-title {
    padding-left: 30px;
    cursor: pointer;

    &:hover {
      @include set_theme_color(background-color, input-default-bg-color);
      @include set_theme_color(color, main-theme-color);
    }

    &.active {
      @include set_theme_color(background-color, menu-tab-bg-color);
      @include set_theme_color(color, main-theme-color);
    }
  }
  .item-title {
    margin: 0 15px 18px 0;
  }

  .item-desc {
    margin: 0 0 18px 15px;
    @include set_theme_color(color, font-disabled-color);
  }
  .title-text {
    margin-left: 10px;
  }
  .right-content {
    flex: 1;
  }
  .param-form {
    overflow-y: auto;
    padding-left: 8px;
    height: 99%;
    width: 100%;
  }
}
</style>
